/**
 * In-memory access token store.
 * Never persisted to localStorage/sessionStorage — lives only in JS heap.
 * The refresh token lives exclusively in an httpOnly cookie managed by the server.
 */

let _accessToken: string | null = null;

export function getAccessToken(): string | null {
  return _accessToken;
}

export function setAccessToken(token: string | null): void {
  _accessToken = token;
}

/**
 * Reads the unverified `exp` claim (seconds since epoch) from a JWT's
 * payload segment. Base64url decode only — no signature check, the server
 * is the sole verifier. Used so AuthProvider can schedule its own proactive
 * refresh; returns null for anything that isn't a well-formed JWT with exp.
 */
export function getAccessTokenExpiresAtMs(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const exp = (JSON.parse(json) as { exp?: unknown }).exp;
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}
